/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { List, Map } from "immutable";
import {
    Row, Col, Spin, Popconfirm, Icon, Checkbox, Modal, message
} from "antd";
import {
    fetchCaseDocumentChecklist,
    updateCaseDetail,
    fetchCompanyChecklist
} from "store/actions";
import CaseService from "services/case-service";
import { Table } from "components";
import CASES_COLS from "constants/document-checklist-cols";
import _startCase from "lodash/startCase";
import PODForm from "forms/pskit-pod-form";
import { AddressRecord, AssociateRecord } from "records/company-record";
import CompanyService from "services/company-service";
import AddAddressForm from "forms/add-address-form";
import "styles/table.css";
import ApplicantDataParser from "forms/signzy-applicant-create-form";
import shortID from "uuid/v4";
import { SaveProxy } from "utilities/save-proxy";
import {
    RECEIVED_DOCUMENTS, PAYEE_NAME, SENDER_TYPE,
    RECEIVED_BY, PENDENCY, PENDENCY_REASON, COURIER_COMPANY
} from "constants/enums";
import "styles/case-document-checklist.css";
import { STATE_STATUS } from "../../constants";
const proxy = new SaveProxy();

const SEC_OPS = [
    {
        label: "I confirm that the signature on cheques match the PAN signature",
        value: "sign_match_pan_and_cheque",
        key: 1
    },
    {
        label: "I confirm that name on cheque matches with the entity name on GST certificate",
        value: "name_match_cheque_and_gst_certi",
        key: 2,
    },
    {
        label: "Write Cheques in favour of 'DESIDERATA IMPACT VENTURES PVT LTD'",
        value: "cheque_in_favour_of_progcap",
        key: 3
    }
];
class CompanyDocumentChecklist extends React.Component {

    state = {
        showPodForm: false,
        showAddressModal: false,
        associates:
            this.props.associates && this.props.associates.size
                ? this.props.associates
                : this.props.ASSOCIATES_EDIT
                    ? new Map({
                        [this.baseID]: new AssociateRecord({
                            type: 1
                        })
                    })
                    : new Map({}),
        addresses:
            this.props.addresses && this.props.addresses.size
                ? this.props.addresses.mapEntries(([, v]) => [v.associate, v])
                : new Map({ [this.baseID]: new AddressRecord() }),
        showAddAssociateModal: false,
        newlyAddedAssociate: null,
        associateType: null,
        showRemoveModal: false,
        associateId: "",
        showPodFormDetails: false
    };

    addressData = {};
    formRef = React.createRef();

    caseId = this.props.caseId;

    componentDidMount() {
        this.fetchChecklist()        
    }

    fetchChecklist() {
        this.props.fetchCompanyChecklist(this.props.companyId);        
    }

    onChangeSecurityChequeIssues = (values) => {
        this.securityChequeValues = values;
    }

    onCancelSecurityCheques = () => {
        this.securityChequeValues = null;
    }

    onConfirmSecurityCheques = () => {
        // let data = {};
        // SEC_OPS.map(_ => {
        //     if(this.securityChequeValues && this.securityChequeValues.includes(_.value)) {
        //         data = {
        //             ...data,
        //             [_.value]: true
        //         };
        //     } else {
        //         data = {
        //             ...data,
        //             [_.value]: false
        //         };
        //     }
        // });
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetails.set(
                "sign_match_pan_and_cheque", this.securityChequeValues && this.securityChequeValues.includes("sign_match_pan_and_cheque")
            )
                .set(
                    "name_match_cheque_and_gst_certi", this.securityChequeValues && this.securityChequeValues.includes("name_match_cheque_and_gst_certi")
                )
                .set(
                    "cheque_in_favour_of_progcap", this.securityChequeValues && this.securityChequeValues.includes("cheque_in_favour_of_progcap")
                )
        );
    }

    getSecurityChequeTitle = () => {
        const { self_declaration } = this.props;
        let keys = Object.keys(self_declaration).filter(_ => self_declaration[_] === true);
        return(
            <div className="d-flex flex-column security-cheques">
                <span style={{fontSize: "12px", fontWeight: "bold"}}>
                    {"Self Declaration:"}
                </span>
                <Checkbox.Group
                    defaultValue={keys}
                    options={SEC_OPS}
                    onChange={this.onChangeSecurityChequeIssues}
                />
            </div>
        );
    }

    getSecurityChequeDetails = (name) => {
        return (
            <React.Fragment>
                <span className="mr-5">{name}</span>
                <Popconfirm
                    onConfirm={this.onConfirmSecurityCheques}
                    onCancel={this.onCancelSecurityCheques}
                    title={this.getSecurityChequeTitle()}
                    okText={"Save"}
                    cancelText={"Cancel"}
                >
                    <Icon type="info-circle" />
                </Popconfirm>
            </React.Fragment>
        );
    }

    onSubmitNewApplicantForm = (associateId, associateRecord, addressRecord, docList={}) => {
        let data = {
            address: addressRecord.formValues,
            ...associateRecord.formValues,
            document: Object.keys(docList),
            company: this.props.companyId
        };

        CaseService.createCaseAssociateAndAddress(this.props.caseId, data).then(() => {
            message.success("Associate Created");
            this.props.fetchCaseDocumentChecklist(this.props.caseId);
            this.onCloseModal();
        }).catch((error) => {
            message.error("Failed to Create Associate");
        });
    }

    onCloseModal = () => {
        this.setState({
            showAddAssociateModal: false,
            newlyAddedAssociate: null,
            associateType: null,
        });
    }
    onCloseRemoveModal = () => {
        this.setState({
            showRemoveModal: false
        });
    }

    showAddApplicantModal = () => {
        const id = shortID();
        proxy.attach(id);
        this.setState({
            associates: this.state.associates.set(
                id,
                new AssociateRecord({
                    type: 1
                })
            ),
            addresses: this.state.addresses.set(id, new AddressRecord()),
            showAddAssociateModal: true,
            newlyAddedAssociate: id,
            associateType: 1
        });
    }

    removeAssociate = () => {
        const payload = {
            is_active: false,
            company: this.props.companyId,
            id: this.state.associateId
        };
        CompanyService.addRemoveAssociate(this.props.companyId , this.state.associateId).then(() => {
            this.fetchChecklist();        
            this.onCloseRemoveModal();
        })
    }

    showRemoveApplicantModal = (associateId) => {
        this.setState({
            showRemoveModal: true,
            associateId: associateId
        });
    }

    getRemoveApplicantsButton = (name, associateId) => {
        if(this.props.checklist.getIn(['pre-sanction' , 'applicants' , 'value'] , []).length > 1){
            return (
                <React.Fragment>
                    <span style={{display: "flex", justifyContent: "space-between", marginRight: "15px"}}>
                        <span className="mr-5">{name}</span>
                        <Icon type="delete" style={{color: "red", cursor: "pointer", marginTop: "3px"}} onClick={() => this.showRemoveApplicantModal(associateId)} />
                    </span>
                </React.Fragment>
            );
        }
        return;
    }

    getApplicantAddButton = (name) => {
        return (
            <React.Fragment>
                <span className="mr-5">{name}</span>
                <Icon type="plus-circle" style={{color: "#246079", cursor: "not-allowed"}}  />
            </React.Fragment>
        );
    }

    openPodForm = () => {
        this.setState({
            showPodForm: true
        });
    }

    closePodForm = () => {
        this.setState({
            showPodForm: false
        });
    }
    togglePodFormEntriesModal = () => {
        this.setState({
            showPodFormDetails: !this.state.showPodFormDetails
        });
    }
    getPODLabel = (label) => {
        return (
            <React.Fragment>
                <span className="mr-5">{label}</span>
                <Icon type={"edit"} />
                <Icon type={"eye"} style={{marginLeft:"5px"}} />
            </React.Fragment>
        );
    }

    createPodDetails = (values) => {
        message.loading("Creating POD Details... ", 0);
        CaseService.createPodDetails({...values, case: this.props.caseId}).then(() => {
            message.destroy();
            message.success("POD Details Created");
            this.closePodForm();
            this.props.fetchCaseDocumentChecklist(this.props.caseId);
        }).catch(() => {
            message.destroy();
            message.error("Failed to Update POD details");
        });
    }

    openAddressModal = (addressType, parsedData) => {
        this.addressData = {
            ...parsedData && parsedData.parse_data_formatted && parsedData.parse_data_formatted.address,
            id: parsedData && parsedData.parse_data_formatted && parsedData.parse_data_formatted.address_id,
            associate: parsedData && parsedData.associate,
            company: parsedData && parsedData.company,
            address_type: addressType,
            is_communication_address: true,
        };
        this.setState({
            showAddressModal: true
        });
    }

    addAddress = () =>
        this.formRef.current.validateFields((err, values) => {
            if (!err) {
                CompanyService.updateSingleAddress(this.props.companyId, new AddressRecord({
                    ...values,
                    company: this.props.companyId,
                    associate: this.addressData.associate
                }).formValues
                ).then(() => {
                    this.closeAddressModal();
                    this.fetchChecklist();
                }).catch(() => {});
            }
        });

    closeAddressModal = () => {
        this.setState({
            showAddressModal: false
        });
    }

    refreshGstFiling = () => {
        CaseService.refreshCompanyGstinFillingDetails(this.props.gstin).then(() => {
            this.fetchChecklist();
        }).catch(() => {});
    }

    getGSTFilingLabel = () => {
        return (
            <React.Fragment>
                <span className="mr-5">{"GST Filing"}</span>
                <Icon type="sync" onClick={this.refreshGstFiling} />
            </React.Fragment>
        );
    }
    getKeyByValue(object, value) {
        let objectJS = object.map((value, key) => ({
            label: key,
            value
        })).toJS();
        let receivedDocsArr = [];
        typeof value === "object" && value?.forEach(item =>receivedDocsArr.push(Object.values(objectJS).find(obj=>obj["value"] === Number(item))?.label));
        return typeof value !== "object" ? Object.values(objectJS).find(obj=>obj["value"] === Number(value))?.label : receivedDocsArr.toString();
    }
      
    render() {
        let data = [];
        let podUploadFields = [];
        let podUploadFieldsRow = null;
        let podDetailsValues = this.props.checklist && this.props.checklist.get("post-sanction") && this.props.checklist.get("post-sanction").pod.value.pod["pod_details"];
        this.props.checklist && this.props.checklist.filter((x, y) => y !=="other_documents").map((v, k) => {
            const subchecklist = Map(v);
            if (!subchecklist.size || k === "requested-document") {
                return;
            }
            data.push({ category: { value: _startCase(k), level: 1 } });
            
            subchecklist.map((subcat, catName) => {
                if (catName === "num_applicants") {
                    data.push({
                        category: { value: this.getApplicantAddButton(subcat.label), level: 3, is_mandatory: subcat.is_mandatory },
                        "col1": subcat.value,
                        "type": subcat.type,
                        "is_mandatory": subcat.is_mandatory,
                        document_id: subcat.document_id,
                        document_url: subcat.document_url
                    });
                }
                else if (catName === "personal_discussion") {
                    data.push({
                        category: { value: subcat.label, level: 3, is_mandatory: subcat.is_mandatory },
                        "col1": subcat.value !== 100 ? <Icon type="check-circle" theme="filled" style={{ color: "#cacaca", paddingRight: "20px" }} />: <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />,
                        "type": subcat.type,
                        document_id: subcat.document_id,
                        document_url: subcat.document_url,
                        "is_mandatory": subcat.is_mandatory
                    });
                }
                else if (catName === "applicants") {
                    const firstObj = subcat.value[0];
                    const firstRow = {
                        category: { value: subcat.label, level: 3 },
                    };
                    if (firstObj) {
                        Object.keys(firstObj).filter(_ => _ !== "name").map((key, index) => {
                            firstRow[`col${index + 1}`] = { 
                                value: firstObj[key].label,
                                level: 3,
                                "type": firstObj[key].type,
                                document_id: firstObj[key].document_id,
                                "is_mandatory": firstObj[key].is_mandatory
                            };
                        });

                        data.push(firstRow);
                        subcat.value.map((_) => {
                            const row = {};
                            row["category"] = { value: this.getRemoveApplicantsButton(_.name.value, _.pan.associate_id), level: 5 };
                            row["col1"] = {
                                value: _.pan && _.pan.value,
                                level: "Bool",
                                "type": _.pan && _.pan.type,
                                document_id: _.pan && _.pan.document_id,
                                document_url: _.pan && _.pan.document_url,
                                associate_id: _.pan && _.pan.associate_id,
                                "is_mandatory": _.pan && _.pan.is_mandatory
                            };
                            row["col2"] = {
                                value: _.aadhar && _.aadhar.value,
                                level: "Bool",
                                "type": _.aadhar && _.aadhar.type,
                                document_url: _.aadhar && _.aadhar.document_url,
                                document_id: _.aadhar && _.aadhar.document_id,
                                associate_id: _.aadhar && _.aadhar.associate_id,
                                "is_mandatory": _.aadhar && _.aadhar.is_mandatory,
                                on_upload: this.openAddressModal.bind(null, 5)
                            };
                            row["col3"] = {
                                value: _.photograph && _.photograph.value,
                                level: "Bool",
                                "type": _.photograph && _.photograph.type,
                                document_url: _.photograph && _.photograph.document_url,
                                document_id: _.photograph && _.photograph.document_id,
                                associate_id: _.photograph && _.photograph.associate_id,
                                "is_mandatory": _.photograph && _.photograph.is_mandatory
                            };
                            row["col4"] = {
                                value: _.mobile_number && _.mobile_number.value,
                                level: "Bool",
                                "type": _.mobile_number && _.mobile_number.type,
                                "is_mandatory": _.mobile_number && _.mobile_number.is_mandatory
                            };
                            row["col5"] = {
                                value: _.email && _.email.value,
                                level: "Bool",
                                "type": _.email && _.email.type,
                                "is_mandatory": _.email && _.email.is_mandatory
                            };
                            row["col6"] = {
                                value: _.address && _.address.value,
                                level: "Bool",
                                "type": _.address && _.address.type,
                                "is_mandatory": _.address && _.address.is_mandatory
                            };
                            data.push(row);
                        });
                    }
                }
                else if (catName === "entity" || catName === "financials") {
                    const firstObj = subcat.value;
                    const firstRow = {
                        category: { value: subcat.label, level: 3 },
                    };

                    const secondRow = {
                        category: { value: "", level: null },
                    };
                    
                    const thirdRow = {
                        category: { value: "", level: null }
                    };

                    const fourthRow = {
                        category: { value: "", level: null }
                    };

                    const fifthRow = {
                        category: { value: "", level: null }
                    };

                    const sixthRow = {
                        category: { value: "", level: null }
                    };

                    Object.keys(firstObj).filter(_ => _ !== "name").map((key, index) => {
                        firstRow[`col${index + 1}`] = {value: firstObj[key].label, level: 3, "is_mandatory": firstObj[key].is_mandatory};
                        secondRow[`col${index + 1}`] = {
                            value: firstObj[key].value,
                            level: "Bool",
                            "type": firstObj[key].type,
                            document_url: firstObj[key].document_url,
                            document_id: firstObj[key].document_id,
                            "is_mandatory": firstObj[key].is_mandatory
                        };

                        if(index > 5) {
                            thirdRow[`col${(index - 6) + 1}`] = {value: firstObj[key].label, level: 3, "is_mandatory": firstObj[key].is_mandatory};
                            fourthRow[`col${(index - 6) + 1}`] = {
                                value: firstObj[key].value,
                                level: "Bool",
                                "type": firstObj[key].type,
                                document_url: firstObj[key].document_url,
                                document_id: firstObj[key].document_id,
                                label: firstObj[key].label,
                                "is_mandatory": firstObj[key].is_mandatory
                            };
                        }
                        if(index > 11){
                            fifthRow[`col${(index - 12) + 1}`] = {value: firstObj[key].label, level: 3, "is_mandatory": firstObj[key].is_mandatory};
                            sixthRow[`col${(index - 12) + 1}`] = {
                                value: firstObj[key].value,
                                level: "Bool",
                                "type": firstObj[key].type,
                                document_url: firstObj[key].document_url,
                                document_id: firstObj[key].document_id,
                                label: firstObj[key].label,
                                "is_mandatory": firstObj[key].is_mandatory
                            };
                        }
                    });

                    data.push(firstRow);
                    data.push(secondRow);
                    if(thirdRow.col1 && fourthRow.col1) {
                        data.push(thirdRow);
                        data.push(fourthRow);
                    }
                    if(fifthRow.col1 && sixthRow.col1) {
                        data.push(fifthRow);
                        data.push(sixthRow);
                    }
                } 
                else if(catName === "pre_sanction_other_progcap") {
                    const firstObj = subcat.value;
                    const firstRow = {
                        category: { value: subcat.label, level: 3, is_mandatory: subcat.is_mandatory },
                    };

                    const secondRow = {
                        category: {
                            value: "",
                            level: null
                        }
                    };

                    firstRow["col1"] = {
                        value: subcat.label, 
                        level: 3,
                        "is_mandatory": subcat.is_mandatory,
                        good_to_have: subcat.good_to_have
                    };
                    
                    secondRow["col1"] = {
                        value: firstObj["other_documents"].value,
                        level: "Bool",
                        "type": firstObj["other_documents"].type,
                        document_id: firstObj["other_documents"].document_id,
                        document_url: firstObj["other_documents"].document_url,
                        "is_mandatory": firstObj["other_documents"].is_mandatory
                    };

                    data.push(firstRow);
                    data.push(secondRow);
                }
                else if (
                    catName === "sales" || 
                    catName === "physical-signed" ||
                    catName === "post-sanction_doc" || 
                    catName === "post-sanctions_others"
                ) {
                    const firstObj = subcat.value;
                    const firstRow = {
                        category: { value: subcat.label, level: 3, is_mandatory: subcat.is_mandatory },
                    };

                    const secondRow = {
                        category: { value: "", level: null }
                    };

                    const thirdRow = {
                        category: { value: "", level: null }
                    };

                    const fourthRow = {
                        category: { value: "", level: null }
                    };

                    Object.keys(firstObj).filter(_ => _ !== "name").map((key, index) => {
                        firstRow[`col${index + 1}`] = {
                            value: firstObj[key].label === "GST Filing" ? this.getGSTFilingLabel() : firstObj[key].label, 
                            level: 3,
                            "is_mandatory": firstObj[key].is_mandatory,
                            good_to_have: firstObj[key].good_to_have
                        };
                        secondRow[`col${index + 1}`] = {
                            value: firstObj[key].value,
                            level: "Bool",
                            "type": firstObj[key].type,
                            document_id: firstObj[key].document_id,
                            document_url: firstObj[key].document_url,
                            "is_mandatory": firstObj[key].is_mandatory,
                            good_to_have: firstObj[key].good_to_have
                        };

                        if(index > 5) {
                            thirdRow[`col${(index - 6) + 1}`] = {
                                value: firstObj[key].label === "Security Cheque" ? 
                                    this.getSecurityChequeDetails(firstObj[key].label) : 
                                    firstObj[key].label === "GST Filing" ? this.getGSTFilingLabel() : firstObj[key].label, 
                                level: 3,
                                "is_mandatory": firstObj[key].is_mandatory,
                                good_to_have: firstObj[key].good_to_have
                            };
                            fourthRow[`col${(index - 6) + 1}`] = {
                                value: firstObj[key].value,
                                level: "Bool",
                                "type": firstObj[key].type,
                                document_id: firstObj[key].document_id,
                                document_url: firstObj[key].document_url,
                                "is_mandatory": firstObj[key].is_mandatory,
                                good_to_have: firstObj[key].good_to_have
                            };
                        }
                    });

                    data.push(firstRow);
                    data.push(secondRow);
                    if(thirdRow.col1 && fourthRow.col1) {
                        data.push(thirdRow);
                        data.push(fourthRow);
                    }
                }
                else if(catName === "pod") {
                    const firstObj = subcat.value;
                    const firstRow = {
                        category: { value: this.getPODLabel(subcat.label), level: 3, is_mandatory: subcat.is_mandatory },
                        col1: {
                            value:  <p className="pod-row-headers">{firstObj.pod.label}</p>, 
                            level: 3,
                            "is_mandatory": firstObj.pod.is_mandatory,
                            good_to_have: firstObj.pod.good_to_have
                        },
                        col2: {
                            value: <p className="pod-row-headers">POD No.</p>,
                            level: 3
                        },
                        col3: {
                            value: <p className="pod-row-headers">Date</p>,
                            level: 3
                        },
                        col4: {
                            value: <p className="pod-row-headers">Courier Company</p>,
                            level: 3
                        },
                        col5: {
                            value: <p className="pod-row-headers">Location</p>,
                            level: 3
                        },
                        col6: {
                            value: <p className="pod-row-headers">Received Docs</p>,
                            level: 3
                        },
                        col7: {
                            value:<p className="pod-row-headers"> Payee Name</p>,
                            level: 3
                        },
                        col8: {
                            value: <p className="pod-row-headers">Cheque Count</p>,
                            level: 3
                        },
                        col9: {
                            value: <p className="pod-row-headers">Sender Type</p>,
                            level: 3
                        },
                        col10: {
                            value: <p className="pod-row-headers">Received By</p>,
                            level: 3
                        },
                        col11: {
                            value: <p className="pod-row-headers">Pendency</p>,
                            level: 3
                        },
                        col12: {
                            value: <p className="pod-row-headers">Pendency Docs</p>,
                            level: 3
                        },
                    };
                    const secondRow = {
                        category: { value: "", level: null },
                        col1: {
                            value: firstObj.pod.value,
                            level: "Bool",
                            "type": firstObj.pod.type,
                            document_id: firstObj.pod.document_id,
                            document_url: firstObj.pod.document_url,
                            "is_mandatory": firstObj.pod.is_mandatory,
                            good_to_have: firstObj.pod.good_to_have
                        },
                        col2: {
                            value: firstObj.pod.pod_details[0] && firstObj.pod.pod_details[0].pod_num,
                            level: 3
                        },
                        col3: {
                            value: firstObj.pod.pod_details[0] && firstObj.pod.pod_details[0].date,
                            level: 3
                        },
                        col4: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(COURIER_COMPANY, firstObj.pod.pod_details[0].courier_company_name),
                            level: 3
                        },
                        col5: {
                            value: firstObj.pod.pod_details[0] && firstObj.pod.pod_details[0].location,
                            level: 3
                        },
                        col6: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(RECEIVED_DOCUMENTS, firstObj.pod.pod_details[0].received_docs_list),
                            level: 3
                        },
                        col7: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PAYEE_NAME, firstObj.pod.pod_details[0].payee_name),
                            level: 3
                        },
                        col8: {
                            value: firstObj.pod.pod_details[0] && firstObj.pod.pod_details[0].cheque_count,
                            level: 3
                        },
                        col9: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(SENDER_TYPE, firstObj.pod.pod_details[0].sender_type),
                            level: 3
                        },
                        col10: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(RECEIVED_BY, firstObj.pod.pod_details[0].received_by),
                            level: 3
                        },
                        col11: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PENDENCY, firstObj.pod.pod_details[0].pendency),
                            level: 3
                        },
                        col12: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PENDENCY_REASON, firstObj.pod.pod_details[0].pendency_reason),
                            level: 3
                        }
                    };
                    const thirdRow = {
                        category: { value: "", level: null },
                        col1: {
                            value:<p className="pod-row-headers">Payee Name</p>,
                            level: 3
                        },
                        col2: {
                            value: <p className="pod-row-headers">Cheque Count</p>,
                            level: 3
                        },
                        col3: {
                            value: <p className="pod-row-headers">Sender Type</p>,
                            level: 3
                        },
                        col4: {
                            value: <p className="pod-row-headers">Received By</p>,
                            level: 3
                        },
                        col5: {
                            value: <p className="pod-row-headers">Pendency</p>,
                            level: 3
                        },
                        col6: {
                            value: <p className="pod-row-headers">Pendency Docs</p>,
                            level: 3
                        },
                    };
                    const fourthRow = {
                        category: { value: "", level: null },
                        col1: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PAYEE_NAME, firstObj.pod.pod_details[0].payee_name),
                            level: 3
                        },
                        col2: {
                            value: firstObj.pod.pod_details[0] && firstObj.pod.pod_details[0].cheque_count,
                            level: 3
                        },
                        col3: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(SENDER_TYPE, firstObj.pod.pod_details[0].sender_type),
                            level: 3
                        },
                        col4: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(RECEIVED_BY, firstObj.pod.pod_details[0].received_by),
                            level: 3
                        },
                        col5: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PENDENCY, firstObj.pod.pod_details[0].pendency),
                            level: 3
                        },
                        col6: {
                            value: firstObj.pod.pod_details[0] && this.getKeyByValue(PENDENCY_REASON, firstObj.pod.pod_details[0].pendency_reason),
                            level: 3
                        },
                    };
                    data.push(firstRow);
                    data.push(secondRow);
                    data.push(thirdRow);
                    data.push(fourthRow);
                    podUploadFieldsRow = {...firstRow};
                    firstObj.pod.pod_details.filter((_, index) => index !== 0).map((key) => {
                        const podRow = {
                            // value: "", level: null,
                            col2 : {
                                value: key.pod_num,
                                level: 3
                            },
                            col3 : {
                                value: key.date,
                                level: 3
                            },
                            col4 : {
                                value: this.getKeyByValue(COURIER_COMPANY, key.courier_company_name),
                                level: 3
                            },
                            col5 : {
                                value: key.location,
                                level: 3
                            },
                            col6 : {
                                value: this.getKeyByValue(RECEIVED_DOCUMENTS, key.received_docs_list),
                                level: 3
                            },
                            col7 : {
                                value: this.getKeyByValue(PAYEE_NAME, key.payee_name),
                                level: 3
                            },
                            col8 : {
                                value: key.cheque_count,
                                level: 3
                            },
                            col9 : {
                                value: this.getKeyByValue(SENDER_TYPE, key.sender_type),
                                level: 3
                            },
                            col10 : {
                                value: this.getKeyByValue(RECEIVED_BY, key.received_by),
                                level: 3
                            },
                            col11 : {
                                value: this.getKeyByValue(PENDENCY, key.pendency),
                                level: 3
                            },
                            col12 : {
                                value: this.getKeyByValue(PENDENCY_REASON, key.pendency_reason),
                                level: 3
                            },
                        };
                        podUploadFields.push(podRow);
                    });
                    let restEntries = Object.keys(secondRow).slice(2).reduce((acc,el)=>{acc[el] = secondRow[el]; return acc;},{});
                    podUploadFields.unshift(restEntries);
                }
                else if (catName === "financials") {
                    const firstObj = subcat.value;
                    if (Object.keys(firstObj).length == 0) {
                        return;
                    }
                    const firstRow = {
                        category: { value: subcat.label, level: 3 },
                    };

                    const secondRow = {
                        category:  "",
                    };

                    Object.keys(firstObj).filter(_ => _ !== "name").map((key, index) => {
                        firstRow[`col${index + 1}`] = { value: firstObj[key].label, level: 3 };
                        secondRow[`col${index + 1}`] = {
                            value: firstObj[key].value,
                            level: "Bool",
                            "type": firstObj[key].type,
                            document_id: firstObj[key].document_id,
                            document_url: firstObj[key].document_url,
                            "is_mandatory": firstObj[key].is_mandatory
                        };
                    });

                    data.push(firstRow);
                    data.push(secondRow);
                    return;
                } else {
                    data.push({
                        "category": _startCase(subcat.label),
                        "col1": {
                            value: subcat.value,
                            level: "Bool",
                            "type": subcat.type,
                            document_id: subcat.document_id,
                            document_url: subcat.document_url,
                            "is_mandatory": subcat.is_mandatory
                        }
                    });
                }
            });
        });
        if(this.props.openAsTab) {
            data = data.map((_, k) => ({
                ..._,
                openAsTab: true,
                fetchChecklist: () => this.props.fetchCaseDocumentChecklist(this.props.caseId),
                companyId: this.props.companyId,
                caseId: this.props.caseId,
                key: k
            }));
        }
        return (
            <Spin spinning={this.props.loading}>
                <Row>
                    <Modal
                        visible={this.state.showRemoveModal}
                        // closable={false}
                        // footer={true}
                        // destroyOnClose
                        // title={"Test"}
                        onOk={this.removeAssociate}
                        onCancel={this.onCloseRemoveModal}
                        okText={"Yes"}
                        cancelText={"NO"}
                    >
                        <span>
                            Are you sure to remove applicant?
                        </span>
                    </Modal>
                    <Modal
                        visible={this.state.showAddAssociateModal}
                        closable={false}
                        footer={null}
                        destroyOnClose
                        onCancel={this.onCloseModal}
                    >
                        <ApplicantDataParser
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            closeModal={this.onCloseModal}
                            associateType={this.state.associateType}
                            onFormSubmit={this.onSubmitNewApplicantForm}
                            associateId={this.state.newlyAddedAssociate}
                        />
                    </Modal>
                    <Modal
                        visible={this.state.showPodForm}
                        closable={true}
                        destroyOnClose={true}
                        title={"Enter POD Details"}
                        footer={null}
                        onCancel={this.closePodForm}
                    >
                        <PODForm
                            update={this.createPodDetails}
                            processing_fee_amount={null}
                            values={podDetailsValues && podDetailsValues[0] && new Map(podDetailsValues[0])}
                        />
                    </Modal>
                    <Modal
                        visible={this.state.showPodFormDetails}
                        closable={true}
                        destroyOnClose={true}
                        title={"View POD Details"}
                        footer={null}
                        onCancel={this.togglePodFormEntriesModal}
                        width={800}
                    >
                        <div className="pod-view-modal-headers">
                            <table className="pod-view-table-border">
                                <thead>
                                    <tr style={{display:"flex"}}>
                                        {podUploadFieldsRow && Object.values(podUploadFieldsRow).splice(2).map((el,idx)=>
                                            el.value && <th key={idx} className="pod-view-row-headers">{el.value}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {podUploadFields.map((el, idx)=>
                                        <tr key={idx} style={{display:"flex"}}>{Object.values(el).map((el,index)=><td key={index} className="pod-view-row-values">{el.value}</td>)}
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal>
                    <Modal
                        visible={this.state.showAddressModal}
                        closable={true}
                        destroyOnClose={true}
                        title={"Update Associate Address"}
                        okText={"Submit"}
                        onOk={this.addAddress}
                        onCancel={this.closeAddressModal}
                    >
                        <AddAddressForm
                            ref={this.formRef}
                            values={new AddressRecord(this.addressData)}
                            addressTypes={[]}
                        />
                    </Modal>
                    <Col span={24} style={{ padding: "10px" }}>
                        <Table
                            columns={CASES_COLS}
                            showTopSection={false}
                            type={"inner"}
                            noRowSelection={true}
                            data={List(data)}
                            size={"small"}
                            pagination={false}
                            antTableConfig={{
                                size: "small",
                                pagination: false,
                                scroll: {
                                    // y: 600
                                },
                                showHeader: false,
                                layout:"fixed",
                            }}
                            className={"checklist-table h-100 bg-white p-10"}
                        />
                    </Col>
                </Row>
            </Spin>
        );
    }


}

CompanyDocumentChecklist.defaultProps = {
    isCompanyCheckList : false
};

CompanyDocumentChecklist.propTypes = {
    route: PropTypes.object,
    checklist: PropTypes.object,
    loading: PropTypes.bool,
    fetchCaseDocumentChecklist: PropTypes.func,
    caseId: PropTypes.number,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    openAsTab: PropTypes.bool,
    companyId: PropTypes.number,
    updateCaseDetail: PropTypes.func,
    caseDetails: PropTypes.object,
    self_declaration: PropTypes.object,
    gstin: PropTypes.string,
    associates: PropTypes.object,
    addresses: PropTypes.object,
    status: PropTypes.string,
    update: PropTypes.func,
    showSpocOnly: PropTypes.bool,
    ASSOCIATES_EDIT: PropTypes.boolean,
    isUserAllowedToEdit: PropTypes.bool,
    isCompanyCheckList : PropTypes.bool

};

const mapStateToProps = (state, props) => ({
    checklist: state.companies.getIn(["checklist", "data"]),
    loading: state.companies.getIn(["checklist", "status"]) == STATE_STATUS.FETCHING,
    caseDetails: state.caseDetails.getIn([props.caseId, "data"]),
    self_declaration: (state.caseDetails.getIn([props.caseId, "data"]) || {}).self_declaration,
    gstin: state.companies.getIn([props.companyId, "data", "gstin"]),
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchCaseDocumentChecklist,
    updateCaseDetail,
    fetchCompanyChecklist
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDocumentChecklist);